import React from 'react'
import { Input as AntInput, ConfigProvider } from 'antd'
import { ReactComponent as SearchIcon } from '../../assets/btn-and-input-icons/bx-search-alt.svg'


const inputStyles = {
    width: '100%',
    fontWeight: 400,
    lineHeight: '19.2px',
}


const Search = ({ ...rest }) => {
  return (
    <>
        <ConfigProvider theme={{
            token: {
              
            },
            components: {
                Input: {
                    controlHeight: 55,
                    paddingInline: 16,
                    borderRadius: 10,
                    fontSize: 16,
                    fontSizeIcon: 16,
                    colorTextPlaceholder: '#8A8A95',
                    colorText: '#231F20',
                    // colorTextDisabled: '#808286',
                    // colorBgContainerDisabled: '#FFFFFF',

                    colorBorder: '#C0C0CF',

                    
                    // colorPrimaryHover: 'rgb(238, 29, 35)',
                    // colorPrimary: 'rgb(238, 29, 35)',
                    // activeShadow: '0 0 0 2px rgb(238, 29, 35, 0.1)'
                }
            }
        }}>
          <AntInput style={inputStyles} 
            placeholder={'Search'}
            prefix={<SearchIcon/>}
            type={'text'}
            {...rest}
          /> 
        </ConfigProvider>
    </>
  )
}

export default Search